<template>
  <nav class="cl-topbar">

    <!-- Left: toggle + breadcrumb -->
    <div class="cl-topbar__left">
      <button class="cl-sidebar__toggle" @click="ctx.emit('toggle')" :title="'Toggle sidebar'">
        <i class="bi bi-layout-sidebar cl-sidebar__toggle-icon"></i>
      </button>
    </div>

    <!-- Right: language + user -->
    <div class="cl-topbar__right">

      <!-- Language selector -->
      <div class="dropdown me-2">
        <button class="cl-topbar__lang-btn" data-bs-toggle="dropdown" aria-expanded="false">
          <img class="cl-lang-flag" v-if="props.multilang.en" src="@/assets/icons/EN.svg" alt="EN" />
          <img class="cl-lang-flag" v-if="props.multilang.se" src="@/assets/icons/SE.svg" alt="SE" />
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" href="#" @click.prevent="languageChangeEvent('en')">
              <img class="cl-lang-flag me-2" src="@/assets/icons/EN.svg" alt="EN" /> English
            </a>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <a class="dropdown-item" href="#" @click.prevent="languageChangeEvent('se')">
              <img class="cl-lang-flag me-2" src="@/assets/icons/SE.svg" alt="SE" /> Swedish
            </a>
          </li>
        </ul>
      </div>

      <!-- User menu -->
      <div class="dropdown">
        <button class="cl-topbar__user-btn" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="cl-topbar__hi">Hi, &nbsp;<b style="color: var(--cl-medium-blue);"> {{ authorName }}</b></span>
          <span class="cl-topbar__avatar">{{ authorInitial }}</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" href="#" @click.prevent="onChangeProfileUser()">
              <i class="fas fa-user me-2"></i>{{ $t('myProfile') }}
            </a>
          </li>
          <!-- <li><hr class="dropdown-divider" /></li>
          <li>
            <a class="dropdown-item" href="#" @click.prevent="onChangePassword()">
              <i class="fas fa-sync me-2"></i>{{ $t('changePassword') }}
            </a>
          </li> -->
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <label class="cl-dark-mode-toggle dropdown-item" @click.stop>
              <span>
                <i :class="isDarkMode ? 'fas fa-moon me-2' : 'fas fa-sun me-2'"></i>
                {{ isDarkMode ? 'Dark Mode' : 'Light Mode' }}
              </span>
              <span class="cl-dark-mode-switch">
                <input type="checkbox" :checked="isDarkMode" @change="toggleDarkMode" />
                <span class="cl-dark-mode-switch__track"></span>
              </span>
            </label>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <a class="dropdown-item" href="#" @click.prevent="logOut()">
              <i class="fas fa-sign-out-alt me-2"></i>{{ $t('signOut') }}
            </a>
          </li>
        </ul>
      </div>

    </div>
  </nav>

  <!-- User Profile Modal -->
  <div class="modal fade" id="userProfileModal" tabindex="-1" aria-labelledby="userProfileModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close()"></button>
        </div>

        <div class="modal-body user-profile-modal">
          <!-- Avatar + name + email -->
          <div class="user-profile-header text-center">
            <div class="user-profile-avatar">
              <i class="fas fa-user"></i>
            </div>
            <h5 class="user-profile-name mb-1">
              {{ `${userProfile.firstName || ''} ${userProfile.lastName || ''}`.trim() }}
            </h5>
            <p class="user-profile-email mb-0">
              {{ userProfile.email }}
            </p>
          </div>

          <!-- Tabs -->
          <ul class="nav nav-tabs user-profile-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link" :class="{ active: activeProfileTab === 'info' }" type="button" role="tab"
                @click="activeProfileTab = 'info'">
                {{ $t('personalInfo') }}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" :class="{ active: activeProfileTab === 'password' }" type="button" role="tab"
                @click="activeProfileTab = 'password'">
                {{ $t('changePassword') }}
              </button>
            </li>
          </ul>

          <div class="tab-content pt-3">
            <!-- Personal info -->
            <div class="tab-pane fade" :class="{ 'show active': activeProfileTab === 'info' }" role="tabpanel">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3 form-group">
                    <label class="form-label">
                      {{ $t('first') + ' ' + $t('name') }}
                      <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control form-control-sm" v-model="userProfile.firstName" required />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3 form-group">
                    <label class="form-label">
                      {{ $t('last') + ' ' + $t('name') }}
                      <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control form-control-sm" v-model="userProfile.lastName" required />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3 form-group">
                    <label class="form-label">
                      {{ $t('email') }}
                      <span class="text-danger">*</span>
                    </label>
                    <input type="email" class="form-control form-control-sm" v-model="userProfile.email"
                      :disabled="isUpdate" required />
                  </div>
                </div>
              </div>
            </div>

            <!-- Change password -->
            <div class="tab-pane fade" :class="{ 'show active': activeProfileTab === 'password' }" role="tabpanel">
              <div class="row">
                <div class="col">
                  <div class="mb-3 form-group">
                    <label class="form-label">
                      {{ $t('oldPassword') }}
                      <span class="text-danger">*</span>
                    </label>
                    <div class="password-input-wrapper">
                      <input :type="showOldPassword ? 'text' : 'password'"
                        class="form-control form-control-sm password-input" v-model="changePasswordForm.oldPassword"
                        required />
                      <button type="button" class="btn btn-sm password-toggle-btn"
                        @click="showOldPassword = !showOldPassword">
                        <i :class="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="mb-3 form-group">
                    <label class="form-label">
                      {{ $t('newPassword') }}
                      <span class="text-danger">*</span>
                    </label>
                    <div class="password-input-wrapper">
                      <input :type="showNewPassword ? 'text' : 'password'"
                        class="form-control form-control-sm password-input" v-model="changePasswordForm.newPassword"
                        required />
                      <button type="button" class="btn btn-sm password-toggle-btn"
                        @click="showNewPassword = !showNewPassword">
                        <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="mb-3 form-group">
                    <label class="form-label">
                      {{ $t('confirmPassword') }}
                      <span class="text-danger">*</span>
                    </label>
                    <div class="password-input-wrapper">
                      <input :type="showConfirmPassword ? 'text' : 'password'"
                        class="form-control form-control-sm password-input" v-model="changePasswordForm.confirmPassword"
                        required />
                      <button type="button" class="btn btn-sm password-toggle-btn"
                        @click="showConfirmPassword = !showConfirmPassword">
                        <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer user-profile-footer">
          <button type="button" class="btn btn-sm btn-outline-close" @click="close()">
            <i class="fas fa-times me-1"></i>{{ $t('close') }}
          </button>
          <button v-if="activeProfileTab === 'info'" type="button" class="btn btn-sm btn-outline-info-reverse"
            @click="onUpdateProfileUser">
            <i class="fas fa-save me-1"></i>{{ $t('update') }}
          </button>
          <button v-else type="button" class="btn btn-sm btn-outline-info-reverse" @click="onChangePasswordFromProfile">
            <i class="fas fa-save me-1"></i>{{ $t('change') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import authService from '@/services/authService';
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import modal from '../common/modalManage';
import { User } from '../master/features/User/User.model';
import agent, { masterServiceBaseURL } from '@/services/agent';
import { PutUserProfileResponse } from '../common/model';
import toasterService from '@/services/toasterService';
import { LoginDTO } from '@/services/models/login';
import axios, { AxiosResponse } from 'axios';
import preLoader from '@/services/preLoader';
import passwordValidator from '@/services/passwordValidator';
import { ChangePassword, ChangePasswordResponse } from '../master/features/ChangePassword/ChangePassword.model';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    multilang: {
      type: Object,
      default: () => ({ se: false, en: false }),
    },
    language: String,
  },
  emits: ['langchange', 'logout', 'toggle'],
  setup(props, ctx) {
    const route = useRoute();
    const { t } = useI18n();
    const isUpdate = ref(false);
    const userProfile = ref({} as User);
    const activeProfileTab = ref<'info' | 'password'>('info');
    const changePasswordForm = ref<ChangePassword>({} as ChangePassword);
    const showOldPassword = ref(false);
    const showNewPassword = ref(false);
    const showConfirmPassword = ref(false);

    // Dark mode
    const isDarkMode = ref(localStorage.getItem('cl-dark-mode') === 'true');
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark-mode');
    }

    function toggleDarkMode() {
      isDarkMode.value = !isDarkMode.value;
      if (isDarkMode.value) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
      localStorage.setItem('cl-dark-mode', String(isDarkMode.value));
    }

    const authorName = computed(() => {
      return authService.getFullName() || authService.getUserEmail() || '';
    });

    const authorInitial = computed(() => {
      const name = authorName.value;
      return name ? name.charAt(0).toUpperCase() : '?';
    });

    const parentRoute = computed(() => {
      const matched = route.matched;
      if (matched.length >= 2) {
        return matched[matched.length - 2].name as string || '';
      }
      // Derive from path e.g. /finance/account → Finance
      const parts = route.path.split('/').filter(Boolean);
      if (parts.length >= 2) {
        return parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
      }
      return '';
    });

    const currentRoute = computed(() => {
      const name = route.name as string;
      if (name) return name.charAt(0).toUpperCase() + name.slice(1);
      const parts = route.path.split('/').filter(Boolean);
      if (parts.length > 0) {
        const last = parts[parts.length - 1];
        return last.charAt(0).toUpperCase() + last.slice(1);
      }
      return '';
    });

    function languageChangeEvent(code: string) {
      ctx.emit('langchange', code);
    }

    function logOut() {
      ctx.emit('logout');
    }

    function onChangePassword() {
      activeProfileTab.value = 'password';
      changePasswordForm.value = {} as ChangePassword;
      // ensure profile data is present for header
      const fullName = authService.getFullName() as string | undefined | null;
      if (fullName) {
        userProfile.value.firstName = String(fullName.split(' ').shift());
        userProfile.value.lastName = fullName.split(' ').filter((_, i) => i > 0).join(' ');
      }
      userProfile.value.email = authService.getUserEmail();
      modal.Open('userProfileModal');
    }

    function onChangeProfileUser() {
      isUpdate.value = true;
      const fullName = authService.getFullName() as string | undefined | null;
      if (fullName) {
        userProfile.value.firstName = String(fullName.split(' ').shift());
        userProfile.value.lastName = fullName.split(' ').filter((_, i) => i > 0).join(' ');
      }
      userProfile.value.email = authService.getUserEmail();
      activeProfileTab.value = 'info';
      changePasswordForm.value = {} as ChangePassword;
      modal.Open('userProfileModal');
    }

    async function onUpdateProfileUser() {
      const payload = {
        firstName: userProfile.value.firstName,
        lastName: userProfile.value.lastName,
        email: userProfile.value.email,
      };
      preLoader.show();
      const response = await axios
        .put<PutUserProfileResponse>(`${masterServiceBaseURL}v1/user/PutUserProfile`, payload, {
          headers: { Authorization: `Bearer ${authService.getToken()}` },
        })
        .then((response: AxiosResponse<PutUserProfileResponse>) => response && response.data);
      if (response && response.result) {
        const getUser = authService.getJwtUser() as LoginDTO;
        getUser.name = `${userProfile.value.firstName} ${userProfile.value.lastName}`;
        authService.setJwtUser(getUser);
        toasterService.success(t('userProfileUpdated') || 'User profile updated successfully!');
        modal.Close('userProfileModal');
      }
      preLoader.hide();
    }

    async function onChangePasswordFromProfile() {
      const post: ChangePassword = { ...changePasswordForm.value };
      post.email = authService.getUserEmail();

      const passwordValidity = passwordValidator.ValidatePassword(post.newPassword);
      if (!passwordValidity.isValid) {
        toasterService.warn(t(passwordValidity.message));
        return;
      }

      if (post.newPassword !== post.confirmPassword) {
        toasterService.warn(t('msgPasswordConfirmPassword'));
        return;
      }

      agent.setBaseUrl(masterServiceBaseURL);
      const response = await agent.post<ChangePasswordResponse>(
        'v1/account/changepassword',
        post
      );
      if (response && response.result) {
        changePasswordForm.value = {} as ChangePassword;
        toasterService.success(t('Password changed successfully!'));
        activeProfileTab.value = 'info';
      }
    }

    function close() {
      modal.Close('userProfileModal');
      activeProfileTab.value = 'info';
      changePasswordForm.value = {} as ChangePassword;
    }

    return {
      props, ctx,
      languageChangeEvent, logOut,
      authorName, authorInitial, parentRoute, currentRoute,
      onChangePassword, onChangeProfileUser, isUpdate, userProfile, close, onUpdateProfileUser,
      activeProfileTab, changePasswordForm, onChangePasswordFromProfile,
      showOldPassword, showNewPassword, showConfirmPassword,
      isDarkMode, toggleDarkMode,
    };
  },
});
</script>